import request from '@/utils/request'
import { downloadBlob } from '@/utils/download'
const apiPath = '/pay/payMerchant/tee'
const payMerchantApi = {
  /**
   * 新增【微信支付管理】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【微信支付管理】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  addOrUpdateConfig(data) {
    return request.post(apiPath + '/addOrUpdateConfig', data)
  },
  /**
   * 分页查询【微信支付管理】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查询【微信支付管理】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },

  /**
   * 批量删除【微信支付管理】
   */
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  },
  setIsEnable(data) {
    return request.post(apiPath + '/setEnable', data)
  },
  /**
   * 导出商户号列表。
   * 传的是和列表同一套筛选条件，后端不分页、导全量。
   */
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '城市公司商户号配置.xlsx'))
  },
  /**
   * 下载批量导入模板
   */
  downloadTemplate() {
    return request.get(`${apiPath}/template`, { responseType: 'blob' })
      .then(res => downloadBlob(res, '城市公司商户号导入模板.xlsx'))
  },
  /**
   * 批量导入商户号，返回成功/失败数与失败原因
   */
  importExcel(formData) {
    return request.post(`${apiPath}/import`, formData)
  },

}
export default payMerchantApi
